<template>
	<div
		:class="[visitor.color]"
		:style="{top: `${computedY}px`, left: `${computedX}px`}"
		class="user-pointer"
	>
		<i class="fas fa-location-arrow"></i>
		<span>{{ visitor.name }}</span>
	</div>
</template>

<script>
import {ref, computed} from 'vue';
import {Scale} from '@/services/canvas/Scale';
import { useMapArea } from '@/modules/map-editor';

export default {
	props: {
		visitor: {
			type: Object,
			default: null
		},
		ctx: {
			type: Object,
			default: null
		},
		zoomLevel: {
			type: Number,
			default: 1
		},
		pixelRatio: {
			type: Number,
			default: 1
		}
	},
	setup(props) {
		const { mapArea } = useMapArea();
		const computedX = computed(() =>
			Scale.x(props.visitor.pointer.x + mapArea.x, props.ctx.canvas.width / 2, props.zoomLevel) / props.pixelRatio
		);
		const computedY = computed(() =>
			Scale.y(props.visitor.pointer.y + mapArea.y, props.ctx.canvas.height / 2, props.zoomLevel) / props.pixelRatio
		);
		
		return {
			computedX,
			computedY
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/user/user-pointer";
</style>
